export class Controller {

    isChecked() {
        return this.selectables().every((item) => item.isSelected);
    }

    isVisible() {
        return !!this.selectables().length;
    }

    toggle() {
        const checked = this.isChecked();
        this.selectables().forEach((item) => item.isSelected = !checked);
    }

    isSelectable(item) {
        return !this.itemSelectable || this.itemSelectable(item);
    }

    selectables() {
        return this.items.filter((item) => this.isSelectable(item));
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/smart-table/select/st-select-all.controller.js